module.exports = __webpack_public_path__ + "static/media/home_temp_2.1568b380.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_temp_2.svg
// module id = 541
// module chunks = 0